import React,{useEffect,useState,useRef,useCallback,useMemo} from 'react'
import '../styles/mainBody.css'
import {EmptyMassage,FeedLoadBar} from './comps'
import{useLocation, useNavigate} from 'react-router-dom';
import LongType from './LongType'
import AllType from './allType'
import ShortsSection from './ShortsSection'
import {useSelector} from 'react-redux'
import { MdOutlineVerified} from 'react-icons/md';
import { FiEdit2, FiTrash2, FiMove } from 'react-icons/fi';
import { BsThreeDotsVertical } from 'react-icons/bs';
import { firstPostImage, parsePostImages } from '../utils/postImages'
import { isPhotoPost, isShortPost, mediaPath, openPostState, openWatchState } from '../utils/mediaRoute'
import { shortsRailAt, shortsSlice } from '../utils/feedLayout'
import UserAvatar from './userAvatar'
import PlaylistSave from './playlistSave'
import { useCreateUpload } from '../hooks/useCreateUpload'
import { profileTabForUpload } from '../utils/createUpload'
import '../styles/createUpload.css'

const ManBody = props => {

 const ref = useRef(null);
 const sentinelRef = useRef(null);
 const [isFetching, setIsFetching] = useState(false);
 const fetching = useRef(false);
 const exhausted = useRef(false);

 const translations = useSelector(state => state.lang_reduse.lang);
 const list = props.type === 'h' || props.type === 'search' || props.type === 'community' || props.isWatch === true
    ? props.list
    : props.type === 'l'
      ? (props.list || []).filter(post => post.type !== 's' && post.type !== 'i')
      : props.type === 's'
        ? (props.list || []).filter(isShortPost)
        : (props.list || []).filter(post => post.type === props.type);
 const uploadJob = useCreateUpload();
 const showUploadTile = Boolean(
   uploadJob &&
   uploadJob.status !== 'done' &&
   !props.isWatch &&
   !props.Visted &&
   props.type === profileTabForUpload(uploadJob.type)
 );
 const dragFromRef = useRef(null);
 const manageRef = useRef(false);
 const orderIdsRef = useRef([]);
 const [orderIds, setOrderIds] = useState([]);
 orderIdsRef.current = orderIds;

 useEffect(() => {
   const ids = (list || []).map(post => String(post.id));
   setOrderIds(prev => {
     if (!prev.length) return ids;
     const have = new Set(ids);
     const kept = prev.filter(id => have.has(id));
     const extra = ids.filter(id => !prev.includes(id));
     return kept.concat(extra);
   });
 }, [list]);

 useEffect(() => {
   if (manageRef.current && !props.manageMode && orderIdsRef.current.length && props.onReorderPosts) {
     props.onReorderPosts(orderIdsRef.current);
   }
   manageRef.current = !!props.manageMode;
 }, [props.manageMode, props.onReorderPosts]);

 const shownList = useMemo(() => {
   const source = list || [];
   if (!orderIds.length) return source;
   const map = new Map(source.map(post => [String(post.id), post]));
   const ordered = orderIds.map(id => map.get(id)).filter(Boolean);
   const leftover = source.filter(post => !orderIds.includes(String(post.id)));
   return ordered.concat(leftover);
 }, [list, orderIds]);

 const movePost = (fromId, toId) => {
   if (!props.onReorderPosts || !fromId || !toId || String(fromId) === String(toId)) return;
   const ids = shownList.map(post => String(post.id));
   const from = ids.indexOf(String(fromId));
   const to = ids.indexOf(String(toId));
   if (from < 0 || to < 0) return;
   const next = ids.slice();
   const [picked] = next.splice(from, 1);
   next.splice(to, 0, picked);
   setOrderIds(next);
   props.onReorderPosts(next);
 };

 const nudgePost = (item, step) => {
   if (!props.onReorderPosts) return;
   const ids = shownList.map(post => String(post.id));
   const from = ids.indexOf(String(item.id));
   const to = from + step;
   if (from < 0 || to < 0 || to >= ids.length) return;
   const next = ids.slice();
   const [picked] = next.splice(from, 1);
   next.splice(to, 0, picked);
   setOrderIds(next);
   props.onReorderPosts(next);
 };

 const loadMore = useCallback(async () => {
   if (fetching.current || exhausted.current || !props.fetchData) return;
   fetching.current = true;
   setIsFetching(true);
   try {
     const added = await props.fetchData();
     if (added && Number(added.longs || 0) === 0 && Number(added.shorts || 0) === 0) {
       exhausted.current = true;
     }
   } finally {
     fetching.current = false;
     setIsFetching(false);
   }
 }, [props.fetchData]);

  const onScroll = () => {
    if (ref.current && props.onFeedScroll) props.onFeedScroll(ref.current.scrollTop);
  };

   useEffect(() => {
     exhausted.current = false;
   }, [props.type, props.fetchData]);

  useEffect(() => {
    const node = ref.current;
    const page = node && node.closest('.homePage, .homeFeedScroll, .WatchPage.homeFeed');
    const root = props.embedded ? (page || null) : node;
    const sentinel = sentinelRef.current;
    if (!sentinel || !props.fetchData) return undefined;
    if (!shownList || shownList.length === 0) return undefined;
    const observer = new IntersectionObserver((entries) => {
      if (entries.some(entry => entry.isIntersecting)) loadMore();
    }, {
      root: root && typeof root.scrollHeight === 'number' ? root : null,
      rootMargin: '800px 0px',
      threshold: 0
    });
    observer.observe(sentinel);
    return () => observer.disconnect();
  }, [props.embedded, props.fetchData, loadMore, props.isload, shownList.length]);

  const navigate = useNavigate();
  const location = useLocation();

  const formatCount = (value) => {
    const n = Number(value);
    if (!Number.isFinite(n) || n < 0) return 0;
    if (n >= 1000000) return `${(n / 1000000).toFixed(1).replace(/\.0$/, '')}M`;
    if (n >= 1000) return `${(n / 1000).toFixed(1).replace(/\.0$/, '')}K`;
    return n;
  };

  return(
    <div onScroll={props.embedded ? undefined : onScroll} ref={ref} className={`${props.Visted?"MainBodyVisted":props.isWatch?(props.embedded ? 'MainBodyWatch isEmbedded' : 'MainBodyWatch'):"MainBody"}${props.embedded && !props.isWatch ? ' isEmbedded' : ''}`}>
      <div key={props.type} className={props.embedded && !props.isWatch ? 'profileTabPane' : undefined}>
      {props.error &&<EmptyMassage list={props.list || []} title={props.error} />}
      <EmptyMassage loading={!!props.isload && !showUploadTile && (!list || list.length === 0) && !(props.isWatch && props.shortsList && props.shortsList.length)} list={showUploadTile || (props.isWatch && props.shortsList && props.shortsList.length) ? [{}] : (list || [])} title={props.emptyTitle || translations.thereisnovideos} />
      {props.manageMode && shownList && shownList.length > 1 ? <p className="postReorderHint">Drag posts or use the arrows to change their order. Tap Done to keep it.</p> : null}
<div className={props.type === 'search' || props.type === 'community' ? 'backsearch' : props.type === 'i' ? 'profileIgGrid' : props.type === 's' || props.type === 'a' ? 'shortsTiktokGrid' : ((props.type === 'l' || props.type === 'm') && !props.isWatch) ? 'longsYoutubeGrid' : ''}>

  {showUploadTile ? (
    <div className={`${props.type === 'i' ? 'inline feed-card igCell' : (props.type === 's' || props.type === 'a') ? 'inline shortsCell' : 'inline feed-card'}`}>
      <div className="uploadTile">
        {uploadJob.previewUrl ? <img src={uploadJob.previewUrl} alt="" /> : null}
        <div className="uploadTileFill">
          <small>{uploadJob.status === 'error' ? 'Failed' : `Uploading ${uploadJob.progress || 0}%`}</small>
          <span className="createUploadTrack" aria-hidden="true">
            <span style={{ width: `${Math.max(4, uploadJob.progress || 0)}%` }} />
          </span>
        </div>
      </div>
    </div>
  ) : null}

  {shownList.map((item,index)=>{return(<React.Fragment key={item.id || index}>
<div
  draggable={!!props.manageMode}
  onDragStart={(event) => {
    if (!props.manageMode) return;
    dragFromRef.current = item.id;
    event.dataTransfer.setData('text/plain', String(item.id));
    event.dataTransfer.effectAllowed = 'move';
  }}
  onDragOver={(event) => { if (props.manageMode) event.preventDefault(); }}
  onDrop={(event) => {
    event.preventDefault();
    event.stopPropagation();
    const fromId = event.dataTransfer.getData('text/plain') || dragFromRef.current;
    movePost(fromId, item.id);
  }}
  onClick={props.manageMode || props.type === 'all' || props.type === 'search' || props.type === 'community'?()=>{}:()=>{
  if (props.type === 's' || props.type === 'a' || isShortPost(item)) {
    navigate(mediaPath(item), { state: openWatchState(item, location) })
    return
  }
  const isPhoto = props.type === 'i' || isPhotoPost(item)
  if (isPhoto) {
    const fromWatch = Boolean(props.isWatch) || String(location.pathname || '').startsWith('/watch')
    const photos = (shownList || []).filter(post => props.type === 'i' || isPhotoPost(post))
    const at = photos.findIndex(post => String(post.id) === String(item.id))
    const rest = fromWatch ? [item] : (at < 0 ? [item] : photos.slice(at))
    navigate(mediaPath(item), { state: openPostState(item, location, { feed: rest, source: fromWatch ? 'watch' : 'list' }) })
    return
  }
  navigate(`/video/${encodeURIComponent(item.id)}`)
}} className={`${props.type==='all'?'': props.type === 'i' ? 'inline feed-card igCell' : (props.type === 's' || props.type === 'a') ? 'inline shortsCell' : 'inline feed-card'}${props.manageMode ? ' isManaging' : ''}`}>

{props.type === 'h' && <LongType postId={item.id} userid={item.userid} communityid={item.communityid || (String(item.link || '').startsWith('c:') ? String(item.link).slice(2) : '')} photo={isPhotoPost(item)} photoCount={parsePostImages(item.image).length} setVideo={true} history={false} thing={()=>props.historyDelete(item.id)} thumbnail={item.thumbnail || firstPostImage(item.image)} title={item.title} tages={item.tages} date={item.date} views={item.views} vlikes={item.vlikes} vdislikes={item.vdislikes} vcomments={item.vcomments} email={item.email} userImg={item.userImg} />}
{props.type === 'i' &&<div className='photoType'><img src={`/api/uploads/${item.thumbnail || firstPostImage(item.image)}`} alt={item.title || 'photo'} />{parsePostImages(item.image).length > 1 && <span className="photoTypeStack">{parsePostImages(item.image).length}</span>}</div>}
{props.type === 's' &&<div className='shortType'><img src={`/api/uploads/${item.thumbnail}`} alt={item.title || 'short'} /><div className="shortTypeBar"><span className="shortTypeViews">{item.views || 0}</span><PlaylistSave className="shortTypeMore" icon={<BsThreeDotsVertical />} post={{ id: item.id, title: item.title, thumbnail: item.thumbnail, type: item.type || 's', image: item.image || item.thumbnail || '' }} /></div></div>}
{props.type === 'a' &&<div className='shortType musicType'><img src={`/api/uploads/${item.thumbnail}`} alt={item.title || 'music'} /><div className="shortTypeBar"><span className="shortTypeViews">{item.title || 'Music'}</span><PlaylistSave className="shortTypeMore" icon={<BsThreeDotsVertical />} post={{ id: item.id, title: item.title, thumbnail: item.thumbnail, type: item.type || 'a', image: item.image || item.thumbnail || '' }} /></div></div>}
{props.type === 'all' && <AllType hash={item.tages} dis={item.title} gouser={()=>{navigate(`../@${item.userid}`)}} type={item.type} image={item.image} vlikes={item.vlikes} vdislikes={item.vdislikes} views={item.views} vcomments={item.vcomments} email={item.email} userImg={item.userImg} userid={item.userid} id={item.id} /> }
{props.type === 'l' && <LongType postId={item.id} userid={item.userid} communityid={item.communityid || (String(item.link || '').startsWith('c:') ? String(item.link).slice(2) : '')} photo={isPhotoPost(item)} photoCount={parsePostImages(item.image).length} recommend={!props.isWatch} featured={props.isWatch && index === 0 && !isPhotoPost(item)} setVideo={props.isWatch? false:true} thumbnail={item.thumbnail || firstPostImage(item.image)} title={item.title} tages={item.tages} date={item.date} views={item.views} vlikes={item.vlikes} vdislikes={item.vdislikes} vcomments={item.vcomments} email={item.email} userImg={item.userImg} />}
{props.type === 'm' && <LongType postId={item.id} userid={item.userid} photo={isPhotoPost(item)} photoCount={parsePostImages(item.image).length} recommend setVideo={true} thumbnail={item.thumbnail || firstPostImage(item.image)} title={item.title} tages={item.tages} date={item.date} views={item.views} vlikes={item.vlikes} vdislikes={item.vdislikes} vcomments={item.vcomments} email={item.email} userImg={item.userImg} />}

{props.manageMode && (
  <div className="postManageBar">
    <button type="button" aria-label="Move earlier" onClick={(e) => { e.stopPropagation(); nudgePost(item, -1); }}>‹</button>
    <button type="button" aria-label="Move later" onClick={(e) => { e.stopPropagation(); nudgePost(item, 1); }}>›</button>
    <button type="button" className="postManageMove" aria-label="Drag to reorder"><FiMove /></button>
    <button type="button" aria-label="Edit post" onClick={(e) => { e.stopPropagation(); props.onEditPost(item); }}><FiEdit2 /></button>
    <button type="button" className="postManageDelete" aria-label="Delete post" onClick={(e) => { e.stopPropagation(); props.onDeletePost(item); }}><FiTrash2 /></button>
  </div>
)}
{props.type === 'search' &&<div className='UserType'>
<UserAvatar src={item.imgurl} name={item.email} alt="" />
<div className="UserTypeMeta">
  <p className="UserTypeName" onClick={()=> props.go(`../@${item.id}`)}>{item.email} {item.followNub > 1 ? <i><MdOutlineVerified /></i> : ''}</p>
  <p className="UserTypeFollowers">{formatCount(item.followNub)} {Number(item.followNub) === 1 ? 'follower' : 'followers'}</p>
</div>
<button type="button" onClick={()=>{props.dispatch(props.normalActions.add_to_follow(item.id,item.email,item.postition,item.job,item.hobby))}}>{props.list2.find(user => user.userid === item.id)?"unfollow":'follow'}</button>
</div>}
{props.type === 'community' &&<div className='UserType'>
<UserAvatar src={item.imgurl} name={item.email} alt="" />
<div className="UserTypeMeta">
  <p className="UserTypeName" onClick={()=> props.go(`/community/${item.id}`)}>{item.email}</p>
  <p className="UserTypeFollowers">{formatCount(item.followNub)} {Number(item.followNub) === 1 ? 'member' : 'members'}</p>
</div>
<button type="button" onClick={()=> props.go(`/community/${item.id}`)}>Open</button>
</div>}

</div>
{props.isWatch ? (() => {
  const rail = shortsRailAt(index)
  if (rail < 0) return null
  const slice = shortsSlice(props.shortsList, rail)
  return slice.length ? <ShortsSection list={slice} /> : null
})() : null}
</React.Fragment> )})}
  {props.isWatch && (!list || list.length === 0) && props.shortsList?.length > 0 ? (
    <ShortsSection list={shortsSlice(props.shortsList, 0)} />
  ) : null}
  </div>
      </div>
      <div ref={sentinelRef} className="feedSentinel" aria-hidden="true" />
      {isFetching && <FeedLoadBar />}
 </div>
  )
}
export default ManBody;
